import * as Models from "../.";

export interface IOpportunityAssociatedEpcCalculationOption {
  opportunityAssociatedEpcCalculationResult: Models.CostCalculation.EpcCalculation.IOpportunityAssociatedEpcCalculationResult;
  selected: boolean;
}

export class OpportunityAssociatedEpcCalculationOption
  implements IOpportunityAssociatedEpcCalculationOption {
  opportunityAssociatedEpcCalculationResult: Models.CostCalculation.EpcCalculation.IOpportunityAssociatedEpcCalculationResult;
  selected: boolean;

  constructor(
    opportunityAssociatedEpcCalculationResult: Models.CostCalculation.EpcCalculation.IOpportunityAssociatedEpcCalculationResult,
    selected: boolean
  ) {
    this.opportunityAssociatedEpcCalculationResult = opportunityAssociatedEpcCalculationResult;
    this.selected = selected;
  }
}
